export default __webpack_public_path__ + "static/media/1181.56de6f2a.png";